 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"affiliates~campaigns~creatives~dashboard~offersAdvanced~payments~payouts~profile~settings~statistics":"affiliates~campaigns~creatives~dashboard~offersAdvanced~payments~payouts~profile~settings~statistics","dashboard~statistics":"dashboard~statistics","statistics":"statistics","affiliates~home~payouts":"affiliates~home~payouts","home":"home","affiliates~campaigns~creatives~dashboard~offersAdvanced~payments~payouts~profile~settings":"affiliates~campaigns~creatives~dashboard~offersAdvanced~payments~payouts~profile~settings","affiliates":"affiliates","payouts":"payouts","campaigns":"campaigns","creatives~offers~offersAdvanced~payments~profile~settings":"creatives~offers~offersAdvanced~payments~profile~settings","creatives":"creatives","offersAdvanced":"offersAdvanced","payments":"payments","profile":"profile","settings":"settings","dashboard":"dashboard","announcements":"announcements","offers":"offers","error404":"error404","login":"login"}[chunkId]||chunkId) + "-legacy." + {"affiliates~campaigns~creatives~dashboard~offersAdvanced~payments~payouts~profile~settings~statistics":"696c76e8","dashboard~statistics":"64221977","statistics":"c8d80076","affiliates~home~payouts":"3c88584c","home":"9397cc5b","chunk-3e9b3bb2":"27f8e331","chunk-511213ac":"d1f2b041","affiliates~campaigns~creatives~dashboard~offersAdvanced~payments~payouts~profile~settings":"bd0986e5","affiliates":"34ccbd6d","payouts":"d2d708c6","campaigns":"c45c8bf1","creatives~offers~offersAdvanced~payments~profile~settings":"58060976","creatives":"c2691bd3","offersAdvanced":"227196d3","payments":"b017a55a","profile":"0f27cf36","settings":"31f0a1af","dashboard":"8b3201ae","announcements":"7c87d99f","chunk-2f808867":"2eda6ae4","chunk-32ac7230":"2edde00b","chunk-386bed31":"53fd54a6","offers":"3544c71c","error404":"91eba574","login":"9a71d62c","chunk-10684609":"90bec840","chunk-03dd3c20":"798611a0","chunk-313a55e0":"e9743782","chunk-429da2ca":"21384535","chunk-53efd9fe":"3c99ca91","chunk-5ed0fe16":"f2a937c8","chunk-4c6913b2":"c073a054","chunk-5fd6208e":"75e942a3","chunk-cf902602":"ef281684","chunk-f101595a":"18cced72","chunk-27922394":"f5c41079","chunk-e1b2101e":"6b2002cb"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"affiliates~campaigns~creatives~dashboard~offersAdvanced~payments~payouts~profile~settings~statistics":1,"dashboard~statistics":1,"statistics":1,"affiliates~home~payouts":1,"home":1,"chunk-3e9b3bb2":1,"affiliates~campaigns~creatives~dashboard~offersAdvanced~payments~payouts~profile~settings":1,"affiliates":1,"payouts":1,"campaigns":1,"creatives~offers~offersAdvanced~payments~profile~settings":1,"creatives":1,"offersAdvanced":1,"payments":1,"profile":1,"settings":1,"dashboard":1,"announcements":1,"chunk-2f808867":1,"chunk-32ac7230":1,"chunk-386bed31":1,"offers":1,"login":1,"chunk-10684609":1,"chunk-03dd3c20":1,"chunk-313a55e0":1,"chunk-429da2ca":1,"chunk-53efd9fe":1,"chunk-5ed0fe16":1,"chunk-4c6913b2":1,"chunk-5fd6208e":1,"chunk-cf902602":1,"chunk-f101595a":1,"chunk-27922394":1,"chunk-e1b2101e":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"affiliates~campaigns~creatives~dashboard~offersAdvanced~payments~payouts~profile~settings~statistics":"affiliates~campaigns~creatives~dashboard~offersAdvanced~payments~payouts~profile~settings~statistics","dashboard~statistics":"dashboard~statistics","statistics":"statistics","affiliates~home~payouts":"affiliates~home~payouts","home":"home","affiliates~campaigns~creatives~dashboard~offersAdvanced~payments~payouts~profile~settings":"affiliates~campaigns~creatives~dashboard~offersAdvanced~payments~payouts~profile~settings","affiliates":"affiliates","payouts":"payouts","campaigns":"campaigns","creatives~offers~offersAdvanced~payments~profile~settings":"creatives~offers~offersAdvanced~payments~profile~settings","creatives":"creatives","offersAdvanced":"offersAdvanced","payments":"payments","profile":"profile","settings":"settings","dashboard":"dashboard","announcements":"announcements","offers":"offers","error404":"error404","login":"login"}[chunkId]||chunkId) + "." + {"affiliates~campaigns~creatives~dashboard~offersAdvanced~payments~payouts~profile~settings~statistics":"9d4358ff","dashboard~statistics":"c6ff4fe3","statistics":"1ea5b3fa","affiliates~home~payouts":"d1c7ccf8","home":"2b47a380","chunk-3e9b3bb2":"b2e29925","chunk-511213ac":"31d6cfe0","affiliates~campaigns~creatives~dashboard~offersAdvanced~payments~payouts~profile~settings":"093d11ba","affiliates":"5c69fd0c","payouts":"b5457562","campaigns":"f4a96ab2","creatives~offers~offersAdvanced~payments~profile~settings":"2ee4aad0","creatives":"c26b6e21","offersAdvanced":"29f19915","payments":"9aa2565a","profile":"3b371113","settings":"95e0394b","dashboard":"5146cf86","announcements":"b9f9442c","chunk-2f808867":"8f4bb35a","chunk-32ac7230":"77cd8dac","chunk-386bed31":"97b767f1","offers":"70435781","error404":"31d6cfe0","login":"dd7977da","chunk-10684609":"c3bb54dd","chunk-03dd3c20":"f3241b38","chunk-313a55e0":"a487a4f9","chunk-429da2ca":"97e08d47","chunk-53efd9fe":"b5ec33da","chunk-5ed0fe16":"8f5edb9e","chunk-4c6913b2":"fae02870","chunk-5fd6208e":"626688d0","chunk-cf902602":"cf7677fc","chunk-f101595a":"11eaa74e","chunk-27922394":"71348c80","chunk-e1b2101e":"4316a606"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["affiliates~home~payouts","home"]]);
 	return startupResult;
